"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _redux = require("@widget-editor/shared/lib/helpers/redux");

var _component = _interopRequireDefault(require("./component"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
} // Components


var _default = (0, _redux.connectState)(function (state) {
  return {
    theme: state.theme
  };
})(_component["default"]);

exports["default"] = _default;